import { apiService } from '../../../shared/services/apiService';
import {
  CustomerGhlContactService,
  CustomerGhlContactServiceResponse,
} from './customerGhlContactService';

export const nutritionCustomerGhlContactService: CustomerGhlContactService = {
  async getConnectedAccountInfo(customerId: number) {
    const resp = await apiService.get<CustomerGhlContactServiceResponse>(
      `/api/user/${customerId}/ghl/contact`,
    );

    return resp.data;
  },

  async refreshConnectionInfo(customerId: number) {
    const resp = await apiService.post<CustomerGhlContactServiceResponse>(
      `/api/user/${customerId}/ghl/contact`,
    );

    return resp.data;
  },
};
